import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import security from "./security";
import auth from "./auth";
import env from "./env";

export default class ScrollService {
  constructor($http, $localStorage, $state, $q, SecurityService, AuthService, $rootScope, $timeout, EnvService) {
    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$q = $q;
    this.$auth = AuthService;
    this.$security = SecurityService;
    this.$rootScope = $rootScope;
    this.galleryPictures = [];
    this.$env = EnvService;
    this.$timeout = $timeout;
    this.after = "";
  }

  loadMoreApplicationsReviewPage(id, offset, max, env, status) {
    console.log("loadMoreApplicationsReviewPage");
    console.log(id);
    console.log(offset);
    console.log(max);
    console.log(env);
    console.log(status);

    var _this = this;

    var url =
      env.getAPIEndPoint() +
      "jbl/v1/subevents/" +
      id +
      "/applications?format=json&offset=" +
      offset +
      "&max=" +
      max +
      "&status=" +
      status +
      "&fields=id,applicant.dateBirth,applicant.numberOfCompletedJobbles,applicant.firstName,applicant.lastName,applicant.undeletedPaymentInfos,applicant.averageRatingReceived,applicant.filePROFILE_IMAGE1IMG_75x75,jobble.id,applicant.id,applicant.homeContactInfo.city,applicant.homeContactInfo.state,applicant.isVerified,applicant.username,applicant.paymentInfos.id";

    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + _this.$auth.getAccessToken(),
      },
      data: {},
    };

    return _this.$http(req);
  }

  sortSet(list, x, header) {
    var _this = this;

    console.log("in side sort set");
    console.dir(list);
    console.dir(x);
    console.dir(header);
    console.dir(header.order);
    var order = header.order;

    switch (x) {
      case 1:
        if (order === 1) {
          list.sort(function (a, b) {
            if (a.applicant.firstName < b.applicant.firstName) return -1;
            if (a.applicant.firstName > b.applicant.firstName) return 1;
            return list;
          });
        } else {
          list.sort(function (a, b) {
            if (a.applicant.firstName > b.applicant.firstName) return -1;
            if (a.applicant.firstName < b.applicant.firstName) return 1;
            return list;
          });
        }

        return list;
        break;

      case 2:
        if (order === 1) {
          list.sort(function (a, b) {
            if (a.applicant.numberOfCompletedJobbles < b.applicant.numberOfCompletedJobbles) return -1;
            if (a.applicant.numberOfCompletedJobbles > b.applicant.numberOfCompletedJobbles) return 1;
            return list;
          });
        } else {
          list.sort(function (a, b) {
            if (a.applicant.numberOfCompletedJobbles > b.applicant.numberOfCompletedJobbles) return -1;
            if (a.applicant.numberOfCompletedJobbles < b.applicant.numberOfCompletedJobbles) return 1;
            return list;
          });
        }

        return list;
        break;
      case 3:
        if (order === 1) {
          list.sort(function (a, b) {
            if (a.applicant.firstName < b.applicant.firstName) return -1;
            if (a.applicant.firstName > b.applicant.firstName) return 1;
            return list;
          });
        } else {
          list.sort(function (a, b) {
            if (a.applicant.firstName > b.applicant.firstName) return -1;
            if (a.applicant.firstName < b.applicant.firstName) return 1;
            return list;
          });
        }

        return list;
        break;

      case 4:
        if (order === 1) {
          list.sort(function (a, b) {
            if (a.applicant.averageRatingReceived < b.applicant.averageRatingReceived) return -1;
            if (a.applicant.averageRatingReceived > b.applicant.averageRatingReceived) return 1;
            return list;
          });
        } else {
          list.sort(function (a, b) {
            if (a.applicant.averageRatingReceived > b.applicant.averageRatingReceived) return -1;
            if (a.applicant.averageRatingReceived < b.applicant.averageRatingReceived) return 1;
            return list;
          });
        }

        return list;
        break;

      default:
        console.log("something went very wrong");
        return list;
    }
  }

  //_this.currentUser.company.id, _this.events.length, 3, _this.$rootScope.sessionParams.page, _this.$rootScope.sessionParams.sort,  _this.$rootScope.sessionParams.order,  _this.$rootScope.sessionParams.isCancelled,  _this.$rootScope.sessionParams.isCompleted, _this.$env, 1
  loadMoreEvents(id, offset, max, page, sort, order, isCancelled, isCompleted, env, status, dates) {
    var _this = this;
    /*
		let url = env.getAPIEndPoint() + 'jbl/v1/companies/' + id + '/events?sort=' + sort +  '&order=' + order + '&max=' + max + '&offset=' + offset + '&conf=web&format=json&isCompleted='+ isCompleted +'&isCancelled=' + isCancelled + '&fields=id,name,orderNumber,isPublished,isClosed,isCompleted,isCancelled,contactInfo.place.timeZoneId,contactInfo.state,contactInfo.city,isChannelDeleted,contactInfo.streetLine1,contactInfo.zipCode,startTime,endTime,isSourcingPost,numberOfApprovedApplications,numberOfPendingApplications,numberOfOpenings,subEvents.id,subEvents.deduppedJobbles.id,subEvents.deduppedJobbles.isPublished,subEvents.deduppedJobbles.jobbleType.name,subEvents.deduppedJobbles.jobbleType.fileJOBBLE_TYPE_FILE01IMG_600x600,subEvents.deduppedJobbles.jobbleType.id,subEvents.deduppedJobbles.applications.id,subEvents.deduppedJobbles.applications.applicationStatus,subEvents.deduppedJobbles.applications.applicant.firstName,subEvents.deduppedJobbles.applications.applicant.lastName';
		if (_.isEmpty(dates)===false){
			url = url + "&startTime="+dates.start+"&endTime="+dates.end;
		}
		//let url = env.getAPIEndPoint()+'jbl/v1/companies/'+id+'/listEvents?max='+max+'&offset='+offset;
		*/
    let url =
      env.getAPIEndPoint() +
      "jbl/v1/companies/" +
      id +
      "/listEvents?sort=" +
      sort +
      "&order=" +
      order +
      "&max=" +
      max +
      "&offset=" +
      offset +
      "&isCompleted=" +
      isCompleted +
      "&isCancelled=" +
      isCancelled;
    if (_.isEmpty(dates) === false) {
      url = url + "&startTime=" + dates.start + "&endTime=" + dates.end;
    }
    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + this.$auth.getAccessToken(),
      },
      data: {},
    };
    return this.$http(req);
  }
}

ScrollService.$inject = ["$http", "$localStorage", "$state", "$q", "security", "auth", "$timeout", "env"];



// WEBPACK FOOTER //
// ./client/app/services/scroll.js